import * as yup from 'yup';

export const getItemAssignmentValidationSchema = (translations: (text: string) => string): yup.AnyObjectSchema =>
  yup.object().shape({
    itemsVolume: yup.string().nullable().required(translations('validation_required')),
    restaurant: yup.object().nullable().required(translations('validation_required')),
    category: yup.object().nullable().required(translations('validation_required')),
  });
